// extracted by mini-css-extract-plugin
export default {"item_title":"RewardsItem_item_title__+keq+","item_image":"RewardsItem_item_image__iZVR2"};